import type { CustomError } from '~/types/error'
import { getHeader } from '~/utils/getHeader'

const isDev = process.env.NODE_ENV === 'development'
const devHost =
  isDev && typeof process !== 'undefined' && process.env.WEBSITE_HOST
    ? process.env.WEBSITE_HOST
    : ''
const serverHost =
  devHost === '' && typeof process !== 'undefined' && process.env.CAREER_IO_HOST
    ? process.env.CAREER_IO_HOST
    : 'https://career.io'
const isBrowser = typeof window !== 'undefined'
const host = isBrowser ? '' : serverHost

type FetcherParams = {
  query?: Record<string, string> | URLSearchParams
  bodyData?: object
} & RequestInit

export const urlBuilder = (url: string) => {
  const hasOrigin = url.indexOf('http') === 0

  if (hasOrigin) {
    const { pathname } = new URL(url)
    // Replacing the origin for the proxy to work correctly in dev mode
    return isDev ? host + pathname : url
  }
  return host + url
}

export const superAppApiFetch = async (
  url: string,
  params: FetcherParams = {},
  ignoreToken = false,
) => {
  const { query, bodyData, body, ...fetchParams } = params
  const lsAllowed = typeof localStorage !== 'undefined'
  const token = lsAllowed ? localStorage.getItem('API_ACCESS_TOKEN') : null

  if (!ignoreToken && !token && lsAllowed) throw new Error('Token does not exist')

  const headers: HeadersInit = {
    Accept: 'application/json',
    ...(body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
    ...(ignoreToken ? {} : { Authorization: `Bearer ${token}` }),
    ...(fetchParams.headers || {}),
  }

  const qs = query ? '?' + new URLSearchParams(query).toString() : ''

  const response = await fetch(urlBuilder(url) + qs, {
    headers,
    body: body || (bodyData ? JSON.stringify(bodyData) : undefined),
    method: fetchParams.method || 'GET',
  })

  if (!response.ok) {
    const contentType = getHeader(response, 'content-type')
    const isJson = contentType && contentType.indexOf('application/json') !== -1

    const error: CustomError = {
      url: urlBuilder(url) + qs,
      status: response.status,
      message: response.statusText,
      body: isJson ? await response.json() : {},
    }
    console.error(error)
    throw new Error(JSON.stringify(error))
  }

  return response.json()
}
